import axios from 'axios';

export default {
	saveLead(params){
		return axios.post('/api/v1/marketing/save-lead', params);
	},
	saveNewsletter(params){
		return axios.post('/api/v1/marketing/save-newsletter', params);
	},
}